import getSkypeOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('discardSkypeOptions', function discardSkypeOptions() {
    var optionState = getSkypeOptions();
    optionState.imNotification = null;
    optionState.callNotification = null;
});
//# sourceMappingURL=discardSkypeOptions.js.map